import { View } from 'backbone.marionette';
import validate from 'validate.js';

import Preloader from '../../../utils/Preloader';

class BaseFormView extends View {

	onClickNext(e) {
		e.preventDefault();
		this.submit();
	}

	onChangeForm(e) {
		return this.hasCustomChangeMethod(e.target.name) ?
			false :
			this.changeField(e.target.name);
	}

	// Overwrite this if needed in extended view
	hasCustomChangeMethod(name) {
		const custom_change_method_field_names = [/*'team_name', 'tipping_team_name'*/];

		return custom_change_method_field_names.indexOf(name) !== -1;
	}

	changeField(field_name) {
		this.model.set({
			[field_name]: this.getFormValues()[field_name]
		});

		const errors = this.validateField(field_name);

		this.model.set({
			errors: {
				...this.model.get('errors'),
				[field_name]: errors
			}
		});

		this.render();
	}

	validate() {
		return validate(this.getFormValues(), this.validationRules(), { fullMessages: false });
	}

	validateField(field_name) {
		return validate.single(
			this.getFormValues()[field_name],
			this.validationRules()[field_name],
			{ fullMessages: false }
		);
	}

	attachValidationErrors(errors) {
		Preloader.hide();
		this.model.set({
			errors
		});
		this.render();
	}

	async validateOnServerPreSubmit() {
		return await validate.async(
			this.getFormValues(),
			this.serverValidationRulesPreSubmit(),
			{ fullMessages: false }
		);
	}
}

export default BaseFormView;